import React, { useState } from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

const Layout = () => {
  const [toggle, setToggle] = useState(false)

  const handleToggleClick = () => {
    setToggle(!toggle)
  }
  return (
    <div className={toggle ? " page_wrapper show" : "page_wrapper"}>
      <Sidebar toggle={toggle} />

      <div className="content_wrapper">
        <Header handleToggleClick={handleToggleClick} />

        <div className="MainContent">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
